import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { AssetEventType } from "../../api/assetEvent";
import { ExternalSystem } from "../../api/externalSystemRequest";

export const CreditNoteExternalSystems : ExternalSystem[] = [
    {
        title: 'Send for Reconciliation',
        description: 'Send your Credit Note to InMatch so that it can be automatically matched',
        icon: '/assets/images/inblock_logo_white.png',
        type: 'inblock',
        assetEventType: AssetEventType.ingested_pts,
        failMessage: 'Failed to send for Reconciliation',
        globalFailMessage: 'Credit Note(s) received an error when sending for Reconciliation',
        successMessage: 'Sent for Reconciliation',
        globalSuccessMessage: 'Credit Note(s) were successfully sent for Reconciliation',
        waitingMessage: 'Waiting for Reconciliation',
        requiredPermission: UserEntitlementCatalogs.SendForReconciliation
    }
];
